import type { LoggerAdapter, LogRecord } from '../logger-types';

export class NoopLoggerAdapter implements LoggerAdapter {
  emit(_record: LogRecord): void {}
}
